export const MIN_SEED_SATS = 100_000

export function seedMinimumSats(): number {
    return MIN_SEED_SATS
}

export function seedQuickSats(configuredSats: number, minimumSeedSats: number | null): number {
    return minimumSeedSats == null ? configuredSats : Math.max(configuredSats, minimumSeedSats)
}
